import { Component, OnInit, ErrorHandler } from '@angular/core';
import { RegistrationService } from '../../../registration.service';
import { ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';

@Component({
  selector: 'app-rank-level-grid',
  templateUrl: './rank-level-grid.component.html',
  styleUrls: ['./rank-level-grid.component.css']
})
export class RankLevelGridComponent implements OnInit {
  maintitle="Rank Levels";
  title = "View Rank Levels";
  ranklevelList: any=[];
  totalItems: number;
  itemsPerPage: number=5 ;
  currentPage: number=1;
  r:any={};
  isSearch: any;
  s: any;
  constructor(private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) { }

  ngOnInit() {
    this.GetAllRankLevelsForMasters(this.itemsPerPage, 1);
  }


  SetUrl(RL_Id:any,mode:any)
  {
    localStorage.setItem('RL_Id',RL_Id);
    localStorage.setItem('mode', mode);
  }

  pageChanged(pageNumber: number) {
    
    //if (this.isSearch)
     // this.onSearch(this.s, this.itemsPerPage, pageNumber);
    //else
      this.GetAllRankLevelsForMasters(this.itemsPerPage, pageNumber);
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
    // if (this.isSearch)
    //   this.onSearch(this.s, this.itemsPerPage, pageNo);
    // else
      this.GetAllRankLevelsForMasters(this.itemsPerPage, pageNo);
  }

  GetAllRankLevelsForMasters(itemsPerPage: number, pageNo: number) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllRankLevels(itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.ranklevelList = data.RankLevelList;
          console.log(data);
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }


  DeleteRankLevel(RL_Id:any)
  {
    
    swal({
      title: 'Are you sure?',
      text: "You want to delete this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.deleteRankLevel(RL_Id).subscribe(
          (data:any) => {
            swal('','RankLevel has been Deleted!','success');
            this.GetAllRankLevelsForMasters(this.itemsPerPage, 1);
            this.s.SearchText = "";
            this.s.SearchCriteria = "";
          },(error) => {
            document.getElementById('loader-spinner').style.display="none";
            this.errorHandler.handleError(error);
          });
      }
    })  
  }


}



// WEBPACK FOOTER //
// ./src/app/Masters/Rank-Levels/rank-level-grid/rank-level-grid.component.ts